export const SIDEBAR_WIDTH = 273;

export const SIDEBAR_WIDTH_SMALL = 211;
